__turbopack_context__.v({
  "button-link": "ButtonLink-module-scss-module__kg5M3W__button-link",
  "button-link__label": "ButtonLink-module-scss-module__kg5M3W__button-link__label",
});
